module.exports = __webpack_public_path__ + "img/chanpin.9938baac.png";